<template>
    <div>
        <el-form
            ref="formData"
            :model="formData"
            label-width="180px"
            size="mini">
        </el-form>
        <div style="text-align:right;">
            <el-button @click="close">取 消</el-button>
            <el-button type="primary" @click="submit">确认</el-button>
        </div>
    </div>
</template>

<script>
import { sp_ad_delete } from "@/api/Product/Product";

export default {
    props: {
        data: {
            type: Object,
            default() {
                return {};
            }
        }
    },
    data() {
        const that = this;
        return {
            date: "",
            formData: {
                start_date: "",
                end_date: ""
            },
            max_date: "",
            min_date: "",
            pickerOptions: {
                disabledDate(time) {
                    const lastDate = new Date(that.data.early_date).getTime();
                    const endDate = new Date(that.data.late_date).getTime();
                    return (
                        time.getTime() > endDate ||
                        time.getTime() < lastDate - 3600 * 24 * 1000
                    );
                }
            }
        };
    },
    mounted() {
        this.formData.start_date = this.data.early_date;
        this.formData.end_date = this.data.late_date;
        this.min_date = this.data.early_date;
        this.max_date = this.data.late_date;
        this.date = [this.data.early_date, this.data.late_date];
    },
    methods: {
        //时间筛选
        datechange(tab) {
            if (tab) {
                this.formData.start_date = tab[0];
                this.formData.end_date = tab[1];
            } else {
                this.formData.start_date = "";
                this.formData.end_date = "";
            }
        },
        submit() {
            sp_ad_delete({
                ad_portfolio_name: this.data.ad_portfolio_name,
                shop_name: this.data.shop_name,
                state: this.data.state,
                ...this.formData
            }).then(res => {
                this.close();
                this.$message({message: "删除成功", type: "success"});
            });
        },
        close() {
            this.$emit("closeExport");
        }
    }
};
</script>
